import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../../Context/UserContextAPI";
import XrayImage from "../XrayImage/XrayImage";
import PDFPrescriptionModal from "./PrescriptionModal/PDFPrescriptionModal";
import axios from "axios";
import VerificationReport from "./Verification/VerificationReport";
import JsBarcode from "jsbarcode";
import QRCode from "qrcode.react";
import "./Verification.scss";

const Verification = ({ children }) => {
  const prescriptionURL = `${process.env.REACT_APP_API_BASE_URL}/prescription`;
  const { settingsData } = useContext(UserContext);
  const { state } = useLocation();
  const navigate = useNavigate();
  const [prescriptionData, setPrescriptionData] = useState([]);
  const urlWithBase64ID = settingsData?.qrcode_url;
  const formattedBirthDate = state?.user?.date_of_birth
    ? new Date(state?.user?.date_of_birth).toLocaleDateString("en-GB")
    : "---";

  const registrationNo = state?.user?.registration_no;

  const formatDeliveryTime = (dateString) => {
    try {
      const date = new Date(dateString);

      if (isNaN(date)) {
        return "";
      }

      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour12: true,
      };

      return new Intl.DateTimeFormat("en-US", options).format(date);
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  };

  const addDaysToDate = (dateString, hours) => {
    const date = new Date(dateString);
    if (!dateString || isNaN(date.getTime())) {
      return "";
    }

    const days = Math.floor(hours / 24);

    date.setDate(date.getDate() + days);

    if (isNaN(date.getTime())) {
      return "";
    }

    return date.toISOString().split("T")[0];
  };

  const receivingDate = state?.user_payment?.createdAt;
  const preparationDuration =
    state?.user?.role_id !== 5
      ? (state?.package?.preparation_duration ?? 0)
      : (state?.max_preparation_duration ?? 0);
  const newDate = addDaysToDate(receivingDate, preparationDuration);

  const patientIdBarcode = document.createElement("canvas");
  JsBarcode(patientIdBarcode, String(registrationNo), {
    height: 20,
    margin: 0,
    displayValue: true,
  });

  const patientIdDataUrl = patientIdBarcode.toDataURL();

  const handlePrescriptionPrint = (e) => {
    navigate("/medical-verification/result/prescription", { state });
    setTimeout(() => {
      window.print();
    }, 1200);
  };

  const fetchPatientInfo = async () => {
    try {
      const prescriptionResponse = await axios.get(
        `${prescriptionURL}/${state?.user_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage?.getItem("jwtToken")}`,
          },
        },
      );
      const prescriptionData = prescriptionResponse.data.data;

      setPrescriptionData(prescriptionData);
    } catch (error) {
      console.error(error);
    }
  };

  const collection = state?.user?.user_collections?.map(
    (collection) => collection.investigation_category?.investigation_group_id,
  );
  const uniqueCollection = [...new Set(collection)];
  useEffect(() => {
    fetchPatientInfo();
  }, []);
  return (
    <div className="verification-test">
      {(uniqueCollection?.length < 2 &&
        (state?.user?.is_pathology_done ||
          state?.user?.is_physical_done ||
          state?.user?.is_radiology_done)) ||
      (uniqueCollection?.length >= 2 &&
        uniqueCollection?.length < 3 &&
        (state?.user?.is_physical_done ? 1 : 0) +
          (state?.user?.is_pathology_done ? 1 : 0) +
          (state?.user?.is_radiology_done ? 1 : 0) >=
          2) ||
      (uniqueCollection?.length >= 3 &&
        state?.user?.is_pathology_done &&
        state?.user?.is_physical_done &&
        state?.user?.is_radiology_done) ? (
        <section className="overflow-hidden">
          {(uniqueCollection?.length < 2 &&
            (state?.user?.is_pathology_done ||
              state?.user?.is_physical_done ||
              state?.user?.is_radiology_done)) ||
          (uniqueCollection?.length >= 2 &&
            uniqueCollection?.length < 3 &&
            (state?.user?.is_physical_done ? 1 : 0) +
              (state?.user?.is_pathology_done ? 1 : 0) +
              (state?.user?.is_radiology_done ? 1 : 0) >=
              2) ||
          (uniqueCollection?.length >= 3 &&
            state?.user?.is_pathology_done &&
            state?.user?.is_physical_done &&
            state?.user?.is_radiology_done) ? (
            <VerificationReport />
          ) : (
            <div className=""></div>
          )}
          {(uniqueCollection?.length < 2 &&
            (state?.user?.is_pathology_done ||
              state?.user?.is_physical_done ||
              state?.user?.is_radiology_done)) ||
          (uniqueCollection?.length >= 2 &&
            uniqueCollection?.length < 3 &&
            (state?.user?.is_physical_done ? 1 : 0) +
              (state?.user?.is_pathology_done ? 1 : 0) +
              (state?.user?.is_radiology_done ? 1 : 0) >=
              2) ||
          (uniqueCollection?.length >= 3 &&
            state?.user?.is_pathology_done &&
            state?.user?.is_physical_done &&
            state?.user?.is_radiology_done) ? (
            <>
              {state?.user?.status === 4 && prescriptionData?.user_id && (
                <div
                  className="pres"
                  // style={{
                  //   pageBreakBefore: "always",
                  // }}
                >
                  <PDFPrescriptionModal data={state} />
                </div>
              )}
              <style jsx>{`
                @media print {
                  @page {
                    margin: 0;
                  }

                  body {
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                  }

                  .pres {
                    width: 100%;
                    overflow: visible;
                  }
                }
              `}</style>
            </>
          ) : (
            <div></div>
          )}
          {(uniqueCollection?.length < 2 &&
            (state?.user?.is_pathology_done ||
              state?.user?.is_physical_done ||
              state?.user?.is_radiology_done)) ||
          (uniqueCollection?.length >= 2 &&
            uniqueCollection?.length < 3 &&
            (state?.user?.is_physical_done ? 1 : 0) +
              (state?.user?.is_pathology_done ? 1 : 0) +
              (state?.user?.is_radiology_done ? 1 : 0) >=
              2) ||
          (uniqueCollection?.length >= 3 &&
            state?.user?.is_pathology_done &&
            state?.user?.is_physical_done &&
            state?.user?.is_radiology_done) ? (
            <div className="p-0 m-0" style={{ pageBreakBefore: "always" }}>
              <XrayImage verification={1} />
            </div>
          ) : (
            <div></div>
          )}
        </section>
      ) : (
        <div
          className="px-5 d-flex flex-column align-items-stretch justify-content-center w-100"
          style={{ height: "60vh" }}
        >
          <div className="row">
            <div className="col-sm-5 h-100">
              <div
                className="w-100 border border-dark border-end-0 d-flex flex-column justify-content-center"
                style={{ height: "90px" }}
              >
                <p className="p-0 m-0 w-100 text-center fw-bold d-flex align-items-center justify-content-center text-dark">
                  DATE: {formatDeliveryTime(newDate, "dd-MM-yyyy hh:mm a")}
                </p>
                <img
                  src={patientIdDataUrl}
                  alt=""
                  className="w-100 img-fluid"
                  style={{
                    height: "60px",
                    paddingLeft: "20px",
                    paddingRight: "20px",
                  }}
                />
              </div>
            </div>
            <div className="col-sm-2 h-100">
              <div
                className="report-avatar border border-end-0 border-dark"
                style={{ height: "90px" }}
              >
                {state?.user?.image ? (
                  <img
                    src={`${process.env.REACT_APP_UPLOAD_URL}/users/${state?.user?.image}`}
                    className="img-fluid"
                    alt="patient"
                    style={{
                      height: "100%",
                      width: "100%",
                    }}
                  />
                ) : (
                  <img
                    src="./dummy.jpg"
                    alt="patient"
                    className="img-fluid"
                    style={{
                      height: "100%",
                      width: "100%",
                    }}
                  />
                )}
              </div>
            </div>
            <div className="col-sm-2 h-100">
              <div
                className="report-avatar border border-end-0 border-dark"
                style={{ height: "90px" }}
              >
                {state?.user?.finger_print ? (
                  <img
                    src={`${process.env.REACT_APP_UPLOAD_URL}/users/${state?.user?.finger_print}`}
                    className="img-fluid"
                    alt=""
                    style={{
                      height: "100%",
                      width: "100%",
                    }}
                  />
                ) : (
                  <div
                    className="p-0 border border-end-0 text-center report-avatar text-dark d-flex align-items-center justify-content-center"
                    style={{
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    No Fingerprint Found
                  </div>
                )}
              </div>
            </div>
            <div className="col-sm-3 h-100">
              <div
                className="d-flex justify-content-center align-items-center w-100 border border-dark"
                style={{ height: "90px" }}
              >
                <Link to={urlWithBase64ID}>
                  <QRCode value={urlWithBase64ID} size={85} />
                </Link>
              </div>
            </div>
          </div>
          <div className="mt-1">
            <div className="col-sm-12">
              <div className="row text-dark">
                <table
                  className="responsive-width1 table-bordered"
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    textAlign: "left",
                  }}
                >
                  <tbody>
                    {/* Row 1 - Name and Client ID */}
                    <tr>
                      <td
                        className="text-uppercase border border-dark ps-1 align-middle"
                        style={{ width: "25%" }}
                      >
                        Name
                      </td>
                      <td
                        className="text-uppercase border border-dark ps-1 align-middle"
                        style={{ width: "25%" }}
                      >
                        {state?.user?.f_name || "---"}
                      </td>
                      <td
                        className="text-uppercase border border-dark ps-1 align-middle"
                        style={{ width: "25%" }}
                      >
                        Client ID
                      </td>
                      <td
                        className="text-uppercase border border-dark ps-1 align-middle"
                        style={{ width: "25%" }}
                      >
                        {state?.user?.reg_prefix || ""}
                        {state?.user?.registration_no || "---"}
                      </td>
                    </tr>

                    {/* Row 2 - Gender and Passport No */}
                    <tr>
                      <td className="text-uppercase border border-dark ps-1 align-middle">
                        Gender
                      </td>
                      <td className="text-uppercase border border-dark ps-1 align-middle">
                        {state?.gender?.name || "---"}
                      </td>
                      <td className="text-uppercase border border-dark ps-1 align-middle">
                        Passport No
                      </td>
                      <td className="text-uppercase border border-dark ps-1 align-middle">
                        {state?.user?.passport_no || "---"}
                      </td>
                    </tr>

                    {/* Row 3 - Date of Birth and Travelling To */}
                    <tr>
                      <td className="text-uppercase border border-dark ps-1 align-middle">
                        Date of Birth
                      </td>
                      <td className="text-uppercase border border-dark ps-1 align-middle">
                        {formattedBirthDate || "---"}
                      </td>
                      <td className="text-uppercase border border-dark ps-1 align-middle fw-bold">
                        Country
                      </td>
                      <td className="text-uppercase border border-dark ps-1 align-middle fw-bold">
                        {state?.country?.name || "---"}
                      </td>
                    </tr>

                    {/* Row 4 - Father Name and Contact Number */}
                    <tr>
                      <td className="text-uppercase border border-dark ps-1 align-middle">
                        Father Name
                      </td>
                      <td className="text-uppercase border border-dark ps-1 align-middle">
                        {state?.father_name || "---"}
                      </td>
                      <td className="text-uppercase border border-dark ps-1 align-middle">
                        Contact Number
                      </td>
                      <td className="text-uppercase border border-dark ps-1 align-middle">
                        {state?.user?.mobile || "---"}
                      </td>
                    </tr>

                    {/* Row 5 - Nationality and Agency */}
                    <tr>
                      <td className="text-uppercase border border-dark ps-1 align-middle">
                        Nationality
                      </td>
                      <td className="text-uppercase border border-dark ps-1 align-middle">
                        {state?.national_country?.nationality || "---"}
                      </td>
                      <td className="text-uppercase border border-dark ps-1 align-middle">
                        {settingsData?.introducer_label}
                      </td>
                      <td
                        className="text-uppercase border border-dark ps-1 align-middle"
                        colSpan={3}
                      >
                        {state?.introducer_user?.f_name || "---"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div
              className="col-12 d-flex align-items-center border border-dark"
              style={{ height: "10vh" }}
            >
              <h4
                className="text-center fw-bold text-uppercase w-100 fs-5"
                style={{
                  color: "red",
                  fontSize: "22px",
                }}
              >
                Your Report is Under Processing...
              </h4>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Verification;
